// extracted by mini-css-extract-plugin
export default {"requirementRowGroup":"RequirementRow_requirementRowGroup__Xzc7R","chevron":"RequirementRow_chevron__obR0c"};